import { render, staticRenderFns } from "./AddImageFromUrlWidget.vue?vue&type=template&id=72939250"
import script from "./AddImageFromUrlWidget.vue?vue&type=script&lang=js"
export * from "./AddImageFromUrlWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports